import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { CustomerInfoService } from 'src/app/services/customer-info.service';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';
import { Product } from 'src/app/models/product.model';
import { CommonService } from 'src/app/services/common.service';
import { FileService } from 'src/app/services/file.service';
import { CustomerService } from 'src/app/services/customer.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';
interface OrderData {
  orderCreateDate: string;
  orderNo: string;
  poNo: string;
  customerId: string;
  realOrderStatus: string;
  realOrderStatusDisplayName: string;
  totalAmount: string;
  netValue: string;
  taxAmount: string;
  currency: string;
  paymentCondition: string;
  shipToName: string;
  shipToAddress: string;
  shipToNo: string;
  shipMethod: string;
  totalWeight: string;
  unitWeight: string;
  totalVolume: string;
  unitVolume: string;
  totalOrderQuantity: string;
  totalCompletedQuantity: string;
  batch:any,
  orderItemInfoVOList: any;
  canCanCel: boolean,
  visible: boolean,
  orderType: string,
  orderTypeDisplayName: string,
}

@Component({
  selector: 'order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.less'],
})
export class OrderHistoryComponent implements OnInit, OnDestroy {
  @Input() tabSelectedIndex: number | undefined;
  private customerSubscription: Subscription | undefined;
  searchFormData!: FormGroup;
  OrderData: OrderData[] = [];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  sortList: any = [];
  isSpinning = true;
  exportLoading = false;
  isVisible: boolean = false;
  order: OrderData | undefined;
  ranges: any;
  isReset:boolean = false;
  isDealerPortal: boolean = false;
  orderTypeFilterList: Array<{ label: string; value: string }> = [];

  constructor(
    private orderService: OrderService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private translate: TranslateService,
    private customerInfoService: CustomerInfoService,
    private cartService: CartService,
    private router: Router,
    private fileService: FileService,
    private customerService: CustomerService,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  codeTypeList: any = [];
  chartData: any = [];
  shippingAddressList: Array<any> = [];
  firstLoading: boolean = true;
  ngOnInit(): void {
    this.searchFormData = this.fb.group({
      orderDate: [[], []],
      orderStatusList: [[], []],
      orderTypeList: ['', []],
      keywordsType: ['orderedMaterialNumber', []],
      keywords: ['', []],
      shipTo: [null, []],
      sortType: ['order_create_date/desc', []],
    });
    this.updateData();
    this.initData().then(()=>{
      this.firstLoading = false;
    })
    this.translate.onLangChange.subscribe(() => {
      if (this.tabSelectedIndex == 0 && !this.firstLoading) {
        this.updateData();
        this.getList();
        this.queryOrderHistoryStatistics();
      }
    });
    this.customerSubscription = this.customerService.selectedCustomer$.subscribe(() => {
      if (this.tabSelectedIndex == 0 && !this.firstLoading && this.router.url.includes('/order/history')) {
        this.initData();
      }
    });
  }
  initData(): Promise<void> {
    return new Promise((resolve) => {
      this.getList();
      let param = {
        pageNum: 1,
        pageSize: -1
      };
      this.customerInfoService.getShippingAddresses(param).subscribe(({ data }) => {
        this.shippingAddressList = data.records || [];
      });
      this.queryOrderHistoryStatistics();
      resolve();
    })
  }

  queryOrderHistoryStatistics(): void {
    this.orderService.queryOrderHistoryStatistics().subscribe((result) => {
      const { openCount, beingProcessedCount, completedCount } = result.rtnData
      this.chartData[2].value = completedCount;
      this.chartData[0].value = openCount;
      this.chartData[1].value = beingProcessedCount;
    });
  }

  setRanges(): void {
    // Get current date
    const startOfMonth = moment().startOf('month').toDate();
    // Get end of current month
    const endOfMonth = moment().endOf('month').toDate();
    // Get start and end of last month
    const startOfLastMonth = moment().subtract(1, 'month').startOf('month').toDate();
    const endOfLastMonth = moment().subtract(1, 'month').endOf('month').toDate();
    // Get start and end of last 3 months
    const startOfLastThreeMonths = moment().subtract(3, 'months').startOf('month').toDate();
    this.ranges = {
      [this.translate.instant('THIS_MONTH')]: [startOfMonth, endOfMonth],
      [this.translate.instant('THIS_YEAR')]: [moment().startOf('year').toDate(), moment().endOf('year').toDate()],
      [this.translate.instant('LAST_MONTH')]: [startOfLastMonth, endOfLastMonth],
      [this.translate.instant('LAST_3_MONTH')]: [startOfLastThreeMonths, endOfLastMonth]
    };
  }

  updateData(): void {
    this.sortList = [
      { name: this.translate.instant('ORDER_DATE_DESC'), value: 'order_create_date/desc' },
      { name: this.translate.instant('ORDER_DATE_ASC'), value: 'order_create_date/asc' },
      { name: this.translate.instant('PO_ASC'), value: 'po_no/asc' },
      { name: this.translate.instant('PO_DESC'), value: 'po_no/desc' },
      { name: this.translate.instant('ORDER_DESC'), value: 'order_no/desc' },
      { name: this.translate.instant('ORDER_ASC'), value: 'order_no/asc' },
      { name: this.translate.instant('TOTAL_AMOUNT_ASC'), value: 'CAST(total_amount  AS SIGNED)/asc' },
      { name: this.translate.instant('TOTAL_AMOUNT_DESC'), value: 'CAST(total_amount  AS SIGNED)/desc' },
    ];
    this.codeTypeList = [
      { name: this.translate.instant('BY_ENTERED_MATERIAL_NUMBER'), value: 'orderedEnterMaterialNumber' },
      { name: this.translate.instant('BY_MATERIAL_NUMBER'), value: 'orderedMaterialNumber' },
      { name: this.translate.instant('By_Bosch_Order_No'), value: 'orderNo' },
      { name: this.translate.instant('BY_CUSTOMER_PURCHASE_ORDER_NO'), value: 'poNo' },
      { name: this.translate.instant('BY_DELIVERY_NUMBER'), value: 'dnNo' },
    ];
    this.orderTypeFilterList = [
      { label: this.translate.instant('ORDER_TYPE_ZCU'), value: 'ZCU' },
      { label: this.translate.instant('ORDER_TYPE_ZEA'), value: 'ZEA' },
      { label: this.translate.instant('ORDER_TYPE_ZSD2'), value: 'ZSD2' },
      { label: this.translate.instant('ORDER_TYPE_ZSO'), value: 'ZSO' },
      { label: this.translate.instant('ORDER_TYPE_YKNA'), value: 'YKNA' },
      { label: this.translate.instant('ORDER_TYPE_ZTP'), value: 'ZTP' },
      { label: this.translate.instant('ORDER_TYPE_ZRP'), value: 'ZRP' },
      { label: this.translate.instant('ORDER_TYPE_YATK'), value: 'YATK' },
      { label: this.translate.instant('ORDER_TYPE_ZRPD'), value: 'ZRPD' },
      { label: this.translate.instant('ORDER_TYPE_ZCA'), value: 'ZCA' },
      { label: this.translate.instant('ORDER_TYPE_ZCA'), value: 'ZCWR' },
      { label: this.translate.instant('ORDER_TYPE_ZCFC'), value: 'ZCFC' },
    ];
    this.chartData = [
      { label: this.translate.instant('OPEN'), value: 0, color: '#9E2896', status: "Open" },
      { label: this.translate.instant('BEING_PROCESSED'), value: 0, color: '#F19F23', status: "Being Processed" },
      { label: this.translate.instant('COMPLETED'), value: 0, color: '#18837E', status: "Completed" },
    ];
    this.setRanges();
  }
  getPercent(completed: string, total: string): number {
    return (parseInt(completed) / parseInt(total)) * 100;
  }
  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "Being Processed":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "Credit blocked":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Open":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Completed":
        color = isBackground ? "#DEF5F3" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  canCancel(date: string): boolean {
    let targetTime = new Date(date);
    targetTime.setHours(new Date(date).getHours() + 1);
    return new Date() <= targetTime;
  }
  clear():void{
    this.isReset = true;
    this.searchFormData.reset({
      orderDate: [],
      orderStatusList: [],
      orderTypeList: '',
      keywordsType: 'orderedMaterialNumber',
      keywords: '',
      shipTo: null,
      sortType: 'order_create_date/desc',
    });
    this.getList();
    this.isReset = false;
  }



  calculatePercentage(completedQuantity: string, orderQuantity: string): number {
    const completed = parseInt(completedQuantity, 10);
    const total = parseInt(orderQuantity, 10);

    if (isNaN(completed) || isNaN(total) || total === 0) {
      return 0;
    }

    return (completed / total) * 100;
  }


  changeKeywords() {
    this.searchFormData.get('keywords')?.setValue('');
  }

  filterOption(input: string, option: any): boolean {
    const shippingAddress = option.nzValue;
    const customerCode = shippingAddress?.customerCode?.toLowerCase() || '';
    const street = shippingAddress?.street?.toLowerCase() || '';
    const customerName = shippingAddress?.customerName?.toLowerCase() || '';

    const search = input.toLowerCase();
    return customerCode.includes(search) || street.includes(search) || customerName.includes(search);
  };

  ngOnDestroy(): void {
    // 取消订阅
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
  }


  /*
   ** search filter
   *
   */
  handleChange(e?: Event): void {
    if(!this.isReset){
      this.pagination.pageIndex = 1;
      setTimeout(() => {
      this.getList();
    }, 0);
    }
  }
  handleStatus(status: string): void {
    this.searchFormData.patchValue({
      orderStatusList: [status]
    });
    
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_quick_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: "history status",
        event_name: 'order quick filter',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: status,
      });
    }
  }

  handleCancel(order: OrderData): void {
    this.order = order;
    this.isVisible = true;
  }

  async cancelOrder(): Promise<void> {
    let params = {
      salesOrderNo: this.order?.orderNo,
    };
    await this.orderService.cancelOrder(params).subscribe((result) => {
      this.isVisible = false;
      if (result.rtnData.result) {
        this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        this.getList();
        this.queryOrderHistoryStatistics();
      } else {
        if (result.rtnData.errorMessage.length > 0) {
          this.message.create(
            'error',
            result.rtnData.errorMessage[0].message
          );
        } else {
          this.message.create(
            'error',
            this.translate.instant('OPERATION_FAILED')
          );
        }
      }
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_cancel_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: 'order cancel',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.order?.orderNo,
      });
    }
  }

  goPage(url: string, data: any): void {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/${url}`], { queryParams: { orderNo: data } });
  }

  async orderAgain(list: any[]): Promise<void> {
    //go to cart
    let products: Product[] = list.map(item => {
      return {
        inputMaterialNumber: item.orderedMaterialNumber,
        expectedDate: item.scheduleConfirmedDeliveryDate,
        quantity: item.orderQuantity
      };
    })
    await this.cartService.addToCart(products).then(() => {
      const country = localStorage.getItem("country");
      this.router.navigateByUrl(`${country}/cart`);
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_add_to_cart_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'order history',
        event_name: 'add to cart',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: '',
      });
    }
  }
  /*
   ** get order history
   *
   */
  getList() {
    this.isSpinning = true;
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    const dynamicObject: { [key: string]: string } = {
      [this.searchFormData.value.keywordsType]:
        this.searchFormData.value.keywords
    };
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      endDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[1]) ?? ''
        : '',
      beginDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[0]) ?? ''
        : '',
      orderStatusStr: this.searchFormData.value.orderStatusList.join(','),
      orderType: this.searchFormData.value.orderTypeList,
      shipTo: this.searchFormData.value.shipTo?.customerCode ?? '',
      column: sortType,
      order: ascType
    };
    this.orderService.queryOrderData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { records, total } = rtnData;
        this.OrderData = records.map((item: any) => {
          return { ...item, visible: false };
        });
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
    if(environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      const keysString = Object.keys(params).join(',');
      const valuesString = Object.values(params)
        .map(value => {
          // 如果值是数组（如 orderType），先转为字符串，或者根据需求处理 null/undefined
          if (Array.isArray(value)) {
            return value.join('|'); // 数组内部建议用不同分隔符，以免混淆
          }
          return value ?? ''; // 处理 null 或 undefined
        })
        .join(',');
      (window as any).dataLayer.push({
        event: 'dp_order_history_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: keysString,
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: valuesString,
      });
    }
  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onInputEnter(event: any): void {
    event.preventDefault();
    this.getList();
  }

  /** */

  /*
   ** export
   *
   */
  async exportExcel(orderNo: string): Promise<void> {
    await this.fileService
      .exportToExcel(
        `/eshop_backend/orderInfo/export?orderNo=${orderNo}`
      ).subscribe(
        (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = `Order_history.zip`;
          if (contentDisposition) {
            fileName = contentDisposition.split('fileName=')[1]?.split(';')[0]?.replace(/"/g, '');
          }
          const blob = new Blob([response.body!], {
            type: 'application/zip',
          });
          saveAs(blob, decodeURIComponent(fileName));
          this.exportLoading = false;
        },
        (error: any) => {
          console.error('Error exporting Excel:', error);
        }
      );
  }
}
